import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import matter from "gray-matter";
import ReactMarkdown from "react-markdown";
import "./blogDetails.css";

const baseURL = "https://mangoholidays.in/mangoblogs";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [content, setContent] = useState("");

  useEffect(() => {
    const loadBlog = async () => {
      try {
        // Fetch blog file list from server
        const listRes = await fetch(`${baseURL}/blogs.json`);
        const files = await listRes.json();

        for (const file of files) {
          const response = await fetch(`${baseURL}/${file}`);
          const text = await response.text();

          const { data, content } = matter(text);

          // Compare slug with front-matter slug
          if (data.slug === slug) {
            setBlog(data);
            setContent(content);

            // Fallback if meta title missing — use main title
            document.title = data.meta_title || data.title;
            break;
          }
        }
      } catch (error) {
        console.error("Error loading blog:", error);
      }
    };

    loadBlog();
  }, [slug]);

  if (!blog) return <p>Loading blog...</p>;

  return (
    <>
      {/* ✅ SEO META TAGS */}
      <Helmet>
        <title>{blog.meta_title || blog.title}</title>

        <meta
          name="description"
          content={
            blog.meta_description ||
            blog.subtitle ||
            "Explore travel guides, tips, and curated journeys with Mango Holidays."
          }
        />

        {/* Open Graph (for Facebook, Instagram, LinkedIn) */}
        <meta property="og:title" content={blog.meta_title || blog.title} />
        <meta
          property="og:description"
          content={
            blog.meta_description ||
            blog.subtitle ||
            "Explore curated travel stories from Mango Holidays."
          }
        />
        <meta property="og:image" content={blog.background_image} />
        <meta
          property="og:url"
          content={`https://mangoholidays.in/blog-details/${blog.slug}`}
        />
        <meta property="og:type" content="article" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.meta_title || blog.title} />
        <meta
          name="twitter:description"
          content={
            blog.meta_description ||
            blog.subtitle ||
            "Explore curated travel stories from Mango Holidays."
          }
        />
        <meta name="twitter:image" content={blog.background_image} />
      </Helmet>

      {/* Banner Section */}
      <section className="banner-section-blog-details">
        <div className="img-container-blog-details">
          <img src="/img/asfalt-dark.png" alt="Banner Unavailable" />
        </div>
        <div className="banner-overlay-blog-details">
          <h1 className="banner-title-blog-details">{blog.title}</h1>
          <p>
            <i className="fa fa-user-alt" /> Mango Holidays |{" "}
            <i className="fa fa-calendar-alt" /> {blog.date}
          </p>
        </div>
      </section>

      {/* Blog Content Section */}
      <section className="content">
        <div className="blog-detail-image">
          <img src={blog.background_image} alt={blog.title} />
        </div>

        <div className="blog-detail-content">
          <ReactMarkdown>{content.replace(/{id}/g, blog.id)}</ReactMarkdown>
        </div>
      </section>

      {/* Bottom tagline */}
      <section className="bottom-tagline">
        <div className="bottom-tagline-background">
          <img src="/img/asfalt-dark.png" alt="Banner Unavailable" />
        </div>
        <div className="bottom-tagline-overlay">
          <h2>Share This Story, Choose Your Platform!</h2>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
